<template>
  <div class="plan-modal plan-doctor">
    <div class="container">
      <div class="plan-content">
        <div class="plan-wrapper">
          <div class="plan-title active w-100 text-center">
            {{ $t("general.planOfDoctor") }} ({{ doctorName }})
          </div>
          <b-col>
            <b-row class="plan-modal-row">
              <template v-if="showDates">
                <b-col sm="2" class="mb-md-0">
                  <b-form-group
                    :invalid-feedback="
                      invalidFeedbackStartDate
                        ? $t(`validation.${invalidFeedbackStartDate}`, {
                            field: $t('general.startDate'),
                          })
                        : ''
                    "
                    :label="$t('general.startDate')"
                    :state="
                      $v.startDate.$dirty
                        ? !$v.startDate.$invalid === false
                          ? false
                          : null
                        : null
                    "
                    :class="{ 'required-group': !$v.startDate.required }"
                    label-for="start-date"
                  >
                    <my-ab-date-picker
                      :ref="startDate ? startDate.toString() : 'start-date'"
                      :type="'date'"
                      :locale="'fa,en'"
                      click-on="all"
                      clearable
                      :show="false"
                      :auto-submit="true"
                      :column="1"
                      v-model="startDate"
                      :toIso="true"
                      :custom-hour="23"
                      id="start-date"
                      :disabled="editMode"
                      :state="
                        $v.startDate.$dirty
                          ? !$v.startDate.$invalid === false
                            ? false
                            : null
                          : null
                      "
                    >
                    </my-ab-date-picker>
                  </b-form-group>
                </b-col>
                <b-col sm="2" class="mb-md-0">
                  <b-form-group
                    :invalid-feedback="
                      invalidFeedbackEndDate
                        ? $t(`validation.${invalidFeedbackEndDate}`, {
                            field: $t('general.endDate'),
                          })
                        : ''
                    "
                    :label="$t('general.endDate')"
                    :state="
                      $v.endDate.$dirty
                        ? !$v.endDate.$invalid === false
                          ? false
                          : null
                        : null
                    "
                    :class="{ 'required-group': !$v.endDate.required }"
                    label-for="end-date"
                  >
                    <my-ab-date-picker
                      :ref="endDate ? endDate.toString() : 'end-date'"
                      :type="'date'"
                      :locale="'fa,en'"
                      click-on="all"
                      clearable
                      :show="false"
                      :auto-submit="true"
                      :column="1"
                      v-model="endDate"
                      :toIso="true"
                      :custom-hour="23"
                      id="end-date"
                      :disabled="editMode"
                      :state="
                        $v.endDate.$dirty
                          ? !$v.endDate.$invalid === false
                            ? false
                            : null
                          : null
                      "
                    >
                    </my-ab-date-picker>
                  </b-form-group>
                </b-col>
              </template>
            </b-row>
          </b-col>
          <b-col class="bg-white border-top pb-1">
            <div class="check-days">
              <b-form-group label="روزهای حضور پزشک:">
                <div class="d-flex">
                  <template v-for="(item , index) in weekDays">
                    <b-form-checkbox
                      v-model="item.checked"
                      @change="whichDaysSelected(item.enName)"
                      class="mr-2"
                      :disabled="editMode"
                    >
                      {{ item.name }}
                    </b-form-checkbox>
                  </template>
                </div>
              </b-form-group>
            </div>
          </b-col>
            <table class="table table-responsive">
                <tr class="fixed-head">
                <td style="width:140px;">روزها</td>
                <td style="width:170px; min-width:148px">زمان شروع</td>
                <td style="width:170px ; min-width:148px">زمان پایان</td>
                <td style="width: 100px ; max-width:175px">فاصله زمانی</td>
                <td style="width:140px">تعداد بیمار در هر نوبت</td>
                <td style="width:170px">واحد</td>
                <td v-if="!advancedSearch" style="width:135px">عملیات</td>
              </tr>
              <tr v-for="(item, index) in sortedRowOfDays" :key="index" class="text-center">
                <td>{{ convertWeekDayName(item.day) }}</td>
                <td  class="td">
                  <date-picker
                    mode="single"
                    type="time"
                    modal
                    :jump-minute="15"
                    :round-minute="true"
                    :auto-submit="false"
                    clearable
                    v-model="item.fromTime"
                    :disabled="editMode"
                    style="margin-top:-1px"
                  >
                  </date-picker>
                </td>
                <td class="td">
                  <date-picker
                    mode="single"
                    type="time"
                    modal
                    :jump-minute="15"
                    :round-minute="true"
                    :auto-submit="false"
                    clearable
                    v-model="item.endTime"
                    :disabled="editMode"
                  ></date-picker>
                </td>
                <td>
                  <b-form-input
                    v-model="item.duration"
                    type="number"
                    step="5"
                    placeholder="دقیقه"
                    :disabled="editMode"
                    style="text-align:center ; width:61px !important"
                  />
                </td>
                <td>
                  <b-form-input
                    type="number"
                    class="text-center maxTurn"
                    v-model="item.maxTurn"
                    :disabled="editMode"
                    style="width:61px !important"
                  />
                </td>
                <td>
                  <b-form-select
                    style="width: 150px"
                   :options="units.length ? units : null"
                    value-field="_id"
                    text-field="title"
                    v-model="item.unitId"
                    :disabled="editMode"
                  ></b-form-select>
                </td>
                <td v-if="!advancedSearch">
                  <button
                    class="btn btn-sm p-0 mx-1"
                    @click="addDay(item.day)"
                    :disabled="editMode"
                  >
                    <b-icon
                      icon="plus-circle"
                      scale="1"
                      variant="success"
                      style="cursor: pointer"
                    ></b-icon>
                  </button>

                  <button
                    class="btn btn-sm p-0"
                    @click="removeDay(index)"
                    :disabled="editMode"
                  >
                    <b-icon
                      icon="x-circle"
                      scale="1"
                      variant="danger"
                      style="cursor: pointer"
                    ></b-icon>
                  </button>
                </td>
              </tr>
            </table>
          <div class="plan-modal-footer">
            <template v-if="advancedSearch">
              <b-button
              size="sm"
              variant="danger"
              class="mx-2"
              @click="$emit('close')"
            >
              بستن
            </b-button>
            </template>
           <template v-else>
            <b-button
                size="sm"
                variant="success"
                @click="createPlan"
                v-if="!editMode"
              >
              ذخیره
            </b-button>
            <b-button
              size="sm"
              variant="success"
              @click="toggleEditMode"
              v-else
            >
              ویرایش
            </b-button>
            <b-button
              size="sm"
              variant="danger"
              class="mx-2"
              @click="$emit('close')"
            >
              بستن
            </b-button>
         </template>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  required,
  requiredIf,
  minLength,
  maxLength,
  sameAs,
} from "vuelidate/lib/validators";
import {
  BButton,
  BFormInput,
  BFormSelect,
  BCol,
  BFormGroup,
  BFormCheckboxGroup,
  BFormCheckbox,
  BRow,
} from "bootstrap-vue";
import datePicker from "vue-persian-datetime-picker";
import { mapGetters } from "vuex";
import MyAbDatePicker from "@/components/wrapper/datePicker/MyAbDatePicker.vue";
import flatPickr from "vue-flatpickr-component";
import MyVSelect from "@/components/wrapper/select/MyVSelect";

export default {
  props: ["doctorIdSelected", "doctorName" ,"advancedSearch"],
  data() {
    return {
      startDate: null,
      endDate: null,
      searchTime: ["00:00", "00:05"],
      selectDays: [],
      countOfQueue: 1,
      searchedUnits: "",
      units: [],
      weekDays: [
        { checked: false, name: "شنبه ها", enName: "Saturdays" },
        { checked: false, name: "یکشنبه ها", enName: "Sundays" },
        { checked: false, name: "دوشنبه ها", enName: "Mondays" },
        { checked: false, name: "سه شنبه ها", enName: "Tuesdays" },
        { checked: false, name: "چهارشنبه ها", enName: "Wednesdays" },
        { checked: false, name: "پنجشنبه ها", enName: "Thursdays" },
        { checked: false, name: "جمعه ها", enName: "Fridays" },
      ],
      doctorId: "",
      modalShow: false,
      saturdays: [],
      sundays: [],
      mondays: [],
      tuesdays: [],
      wednesdays: [],
      thursdays: [],
      fridays: [],
      lastInUsePlan: [],
      rowOfDays: [],
      editMode: false,
      showDates: true,
      errUnit:'',
      errTime:"",
      unitId:'',
      fromTime:'',
      endTime:'',
      duration:"",
      maxTurn:'',
      lastTypingTime:null

    
    };
  },
  components: {
    BFormInput,
    MyAbDatePicker,
    flatPickr,
    required,
    requiredIf,
    minLength,
    maxLength,
    sameAs,
    MyVSelect,
    BFormSelect,
    BButton,
    BCol,
    BFormGroup,
    BRow,
    datePicker,
    BFormCheckboxGroup,
    BFormCheckbox,
  },
  validations() {
    return {
      startDate: {
        required,
      },
      endDate: {
        required,
      },
    };
  },
  methods: {
    toggleEditMode() {
      this.editClicked = true; 
      this.editMode = !this.editMode; 
    },
    createPlan() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$store.commit("SET_IS_LOADING", true);
        let hasError = false;
        let payload = {
          planUserId: this.doctorIdSelected,
          fromDate: this.startDate,
          endDate: this.endDate,
          saturdays: this.rowOfDays
            .filter((item) => item.day === "Saturdays")
            .map((item) => {
              const overlappingTime = this.rowOfDays.find(
            (other) =>
              other.day === item.day &&
              other !== item &&
              (
                (other.fromTime >= item.fromTime && other.fromTime < item.endTime) ||
                (other.endTime > item.fromTime && other.endTime <= item.endTime) ||
                (other.fromTime <= item.fromTime && other.endTime >= item.endTime)
              )
          );

           if (overlappingTime) {
              this.$store.commit("SET_IS_LOADING", false);
                if (!hasError) {
                this.$bvToast.toast(`در روز شنبه تداخل پیدا شد. لطفا تایم کاری را تصحیح کنید.`, {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
              }
              
              return null;
            }

              if( item.unitId === ''){
              this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.MandatoryUnit"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                }
                if (Number(item.duration) % 5 !== 0 || Number(item.duration) == "") {
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.Interval"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                if(Number(item.maxTurn) === null || Number(item.maxTurn) == ""){
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.ErrMaxTurn"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                if(item.fromTime == "" || item.fromTime === null){
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.ErrFromTime"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                
                }
                if(item.endTime == "" || item.endTime === null){
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.ErrEndTime"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                this.unitId = item.unitId
                this.endTime = item.endTime
                this.fromTime = item.fromTime
                this.maxTurn =  Number(item.maxTurn),
                this.duration = Number(item.duration) % 5 !== 0 


              return {
                fromTime: item.fromTime,
                endTime: item.endTime,
                duration: Math.round(Number(item.duration) / 5) * 5,
                maxTurn: Number(item.maxTurn),
                unitId: item.unitId,
              };
            }),
           sundays: this.rowOfDays
            .filter((item) => item.day === "Sundays")
            .map((item) => {
              const overlappingTime = this.rowOfDays.find(
            (other) =>
              other.day === item.day &&
              other !== item &&
              (
                (other.fromTime >= item.fromTime && other.fromTime < item.endTime) ||
                (other.endTime > item.fromTime && other.endTime <= item.endTime) ||
                (other.fromTime <= item.fromTime && other.endTime >= item.endTime)
                  )
              );

              if (overlappingTime) {
              this.$store.commit("SET_IS_LOADING", false);
                if (!hasError) {
                this.$bvToast.toast(`در روز یکشنبه تداخل پیدا شد. لطفا تایم کاری را تصحیح کنید.`, {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
              }
              
              return null;
            }

              if( item.unitId === ''){
              this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.MandatoryUnit"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                }
                if (Number(item.duration) % 5 !== 0 || Number(item.duration) == "") {
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.Interval"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                if(Number(item.maxTurn) === null || Number(item.maxTurn) == ""){
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.ErrMaxTurn"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                if(item.fromTime == "" || item.fromTime === null){
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.ErrFromTime"), {
                  variant: "danger",
                  solid: true,
                });
                return null;
                }
                if(item.endTime == "" || item.endTime === null){
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.ErrEndTime"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                this.unitId = item.unitId
                this.endTime = item.endTime
                this.fromTime = item.fromTime
                this.maxTurn =  Number(item.maxTurn),
                this.duration = Number(item.duration) % 5 !== 0 
              return {
                fromTime: item.fromTime,
                endTime: item.endTime,
                duration: Math.round(Number(item.duration) / 5) * 5,
                maxTurn: Number(item.maxTurn),
                unitId: item.unitId,
              };
            }),
            mondays: this.rowOfDays
            .filter((item) => item.day === "Mondays")
            .map((item) => {
              const overlappingTime = this.rowOfDays.find(
            (other) =>
              other.day === item.day &&
              other !== item &&
              (
                (other.fromTime >= item.fromTime && other.fromTime < item.endTime) ||
                (other.endTime > item.fromTime && other.endTime <= item.endTime) ||
                (other.fromTime <= item.fromTime && other.endTime >= item.endTime)
              )
              );

              if (overlappingTime) {
              this.$store.commit("SET_IS_LOADING", false);
                if (!hasError) {
                this.$bvToast.toast(`در روز دو شنبه تداخل پیدا شد. لطفا تایم کاری را تصحیح کنید.`, {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
              }
              
              return null;
            }

              if( item.unitId === ''){
              this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.MandatoryUnit"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                }
                if (Number(item.duration) % 5 !== 0 || Number(item.duration) == "") {
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.Interval"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                if(Number(item.maxTurn) === null || Number(item.maxTurn) == ""){
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.ErrMaxTurn"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                if(item.fromTime == "" || item.fromTime === null){
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.ErrFromTime"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                if(item.endTime == "" || item.endTime === null){
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.ErrEndTime"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                this.unitId = item.unitId
                this.endTime = item.endTime
                this.fromTime = item.fromTime
                this.maxTurn =  Number(item.maxTurn),
                this.duration = Number(item.duration) % 5 !== 0 

              return {
                fromTime: item.fromTime,
                endTime: item.endTime,
                duration: Math.round(Number(item.duration) / 5) * 5,
                maxTurn: Number(item.maxTurn),
                unitId: item.unitId,
              };
            }),
           tuesdays: this.rowOfDays
            .filter((item) => item.day === "Tuesdays")
            .map((item) => {
              const overlappingTime = this.rowOfDays.find(
            (other) =>
              other.day === item.day &&
              other !== item &&
              (
                (other.fromTime >= item.fromTime && other.fromTime < item.endTime) ||
                (other.endTime > item.fromTime && other.endTime <= item.endTime) ||
                (other.fromTime <= item.fromTime && other.endTime >= item.endTime)
              )
              );

              if (overlappingTime) {
              this.$store.commit("SET_IS_LOADING", false);
                if (!hasError) {
                this.$bvToast.toast(`در روز سه شنبه تداخل پیدا شد. لطفا تایم کاری را تصحیح کنید.`, {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
              }
              
              return null;
            }

              if( item.unitId === ''){
              this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.MandatoryUnit"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                }
                if (Number(item.duration) % 5 !== 0 || Number(item.duration) == "") {
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.Interval"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                if(Number(item.maxTurn) === null || Number(item.maxTurn) == ""){
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.ErrMaxTurn"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                if(item.fromTime == "" || item.fromTime === null){
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.ErrFromTime"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                if(item.endTime == "" || item.endTime === null){
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.ErrEndTime"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                this.unitId = item.unitId
                this.endTime = item.endTime
                this.fromTime = item.fromTime
                this.maxTurn =  Number(item.maxTurn),
                this.duration = Number(item.duration) % 5 !== 0 

              return {
                fromTime: item.fromTime,
                endTime: item.endTime,
                duration: Math.round(Number(item.duration) / 5) * 5,
                maxTurn: Number(item.maxTurn),
                unitId: item.unitId,
              };
            }),
           wednesdays: this.rowOfDays
            .filter((item) => item.day === "Wednesdays")
            .map((item) => {
              const overlappingTime = this.rowOfDays.find(
            (other) =>
              other.day === item.day &&
              other !== item &&
              (
                (other.fromTime >= item.fromTime && other.fromTime < item.endTime) ||
                (other.endTime > item.fromTime && other.endTime <= item.endTime) ||
                (other.fromTime <= item.fromTime && other.endTime >= item.endTime)
              )
              );

              if (overlappingTime) {
              this.$store.commit("SET_IS_LOADING", false);
                if (!hasError) {
                this.$bvToast.toast(`در روز چهار شنبه تداخل پیدا شد. لطفا تایم کاری را تصحیح کنید.`, {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
              }
              
              return null;
            }

              if( item.unitId === ''){
              this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.MandatoryUnit"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                }
                if (Number(item.duration) % 5 !== 0 || Number(item.duration) == "") {
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.Interval"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                if(Number(item.maxTurn) === null || Number(item.maxTurn) == ""){
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.ErrMaxTurn"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                if(item.fromTime == "" || item.fromTime === null){
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.ErrFromTime"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                if(item.endTime == "" || item.endTime === null){
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.ErrEndTime"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                this.unitId = item.unitId
                this.endTime = item.endTime
                this.fromTime = item.fromTime
                this.maxTurn =  Number(item.maxTurn),
                this.duration = Number(item.duration) % 5 !== 0 

              return {
                fromTime: item.fromTime,
                endTime: item.endTime,
                duration: Math.round(Number(item.duration) / 5) * 5,
                maxTurn: Number(item.maxTurn),
                unitId: item.unitId,
              };
            }),
           thursdays: this.rowOfDays
            .filter((item) => item.day === "Thursdays")
            .map((item) => {
              const overlappingTime = this.rowOfDays.find(
            (other) =>
              other.day === item.day &&
              other !== item &&
              (
                (other.fromTime >= item.fromTime && other.fromTime < item.endTime) ||
                (other.endTime > item.fromTime && other.endTime <= item.endTime) ||
                (other.fromTime <= item.fromTime && other.endTime >= item.endTime)
              )
              );

              if (overlappingTime) {
              this.$store.commit("SET_IS_LOADING", false);
                if (!hasError) {
                this.$bvToast.toast(`در روز پنج شنبه تداخل پیدا شد. لطفا تایم کاری را تصحیح کنید.`, {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
              }
              
              return null;
            }

              if( item.unitId === ''){
              this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.MandatoryUnit"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                }
                if (Number(item.duration) % 5 !== 0 || Number(item.duration) == "") {
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.Interval"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                if(Number(item.maxTurn) === null || Number(item.maxTurn) == ""){
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.ErrMaxTurn"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                if(item.fromTime == "" || item.fromTime === null){
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.ErrFromTime"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                if(item.endTime == "" || item.endTime === null){
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.ErrEndTime"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                this.unitId = item.unitId
                this.endTime = item.endTime
                this.fromTime = item.fromTime
                this.maxTurn =  Number(item.maxTurn),
                this.duration = Number(item.duration) % 5 !== 0 

              return {
                fromTime: item.fromTime,
                endTime: item.endTime,
                duration: Math.round(Number(item.duration) / 5) * 5,
                maxTurn: Number(item.maxTurn),
                unitId: item.unitId,
              };
            }),
           fridays: this.rowOfDays
            .filter((item) => item.day === "Fridays")
            .map((item) => {
              const overlappingTime = this.rowOfDays.find(
            (other) =>
              other.day === item.day &&
              other !== item &&
              (
                (other.fromTime >= item.fromTime && other.fromTime < item.endTime) ||
                (other.endTime > item.fromTime && other.endTime <= item.endTime) ||
                (other.fromTime <= item.fromTime && other.endTime >= item.endTime)
              )
            );

            if (overlappingTime) {
              this.$store.commit("SET_IS_LOADING", false);
                if (!hasError) {
                this.$bvToast.toast(`در روز جمعه تداخل پیدا شد. لطفا تایم کاری را تصحیح کنید.`, {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
              }
              
              return null;
            }

              if( item.unitId === ''){
              this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.MandatoryUnit"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                }
                if (Number(item.duration) % 5 !== 0 || Number(item.duration) == "") {
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.Interval"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                if(Number(item.maxTurn) === null || Number(item.maxTurn) == ""){
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.ErrMaxTurn"), {
                  variant: "danger",
                  solid: true,
                });
                return null;
                }
                if(item.fromTime == "" || item.fromTime === null){
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.ErrFromTime"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                if(item.endTime == "" || item.endTime === null){
                  this.$store.commit("SET_IS_LOADING", false);
                  this.$bvToast.toast(this.$t("toastification.ErrEndTime"), {
                  variant: "danger",
                  solid: true,
                });
                hasError = true;
                return null;
                }
                this.unitId = item.unitId
                this.endTime = item.endTime
                this.fromTime = item.fromTime
                this.maxTurn =  Number(item.maxTurn),
                this.duration = Number(item.duration) % 5 !== 0 

              return {
                fromTime: item.fromTime,
                endTime: item.endTime,
                duration: Math.round(Number(item.duration) / 5) * 5,
                maxTurn: Number(item.maxTurn),
                unitId: item.unitId,
              };
            }),
            
        };
        const data = Object.assign({}, { ...payload });
        if (data.saturdays.length === 0) delete data.saturdays;
        if (data.sundays.length === 0) delete data.sundays;
        if (data.mondays.length === 0) delete data.mondays;
        if (data.tuesdays.length === 0) delete data.tuesdays;
        if (data.wednesdays.length === 0) delete data.wednesdays;
        if (data.thursdays.length === 0) delete data.thursdays;
        if (data.fridays.length === 0) delete data.fridays;
        if (( !hasError ) || (this.rowOfDays.length === 0)) {
          this.$store
            .dispatch("plan/createPlan", data)
            .then((res) => {
              this.$store.commit("SET_IS_LOADING", false);
              this.$bvToast.toast(this.$t("toastification.submissionSucceed"), {
                variant: "success",
                solid: true,
              });
              this.$emit("close");
              if (this.editClicked) {
                setTimeout(() => {
                  this.$bvToast.toast(this.$t("toastification.syncPlan"), {
                    title: this.$t("toastification.success"),
                    variant: "success",
                    solid: true,
                  });
                }, 100);
              }else{
                setTimeout(() => {
                  this.$bvToast.toast(this.$t("toastification.createPlan"), {
                    title: this.$t("toastification.success"),
                    variant: "success",
                    solid: true,
                  });
                }, 100);
              }
            })
            .finally(() => {
              this.editClicked = false;
              this.$store.commit("SET_IS_LOADING", false);
            });
          }
      }

    },
    close() {
      this.$emit("close");
    },
    removeDay(index) {
      const dayName = this.rowOfDays[index].day;
      const rows = this.rowOfDays.filter((item) => item.day === dayName);
      if (rows && rows.length === 1) {
        this.weekDays.find((item) => item.enName === dayName).checked = false;
      }
      this.rowOfDays.splice(index, 1);
    },
    addDay(day) {
      const index = this.rowOfDays.findIndex((item) => item.day === day);
      const payload = {
        day: day,
        fromTime: "08:00",
        endTime: "18:00",
        duration: null,
        maxTurn: null,
        unitId: "",
      };
      this.rowOfDays.splice(index + 1, 0, payload);
    },
    whichDaysSelected(dayName) {
      const item = this.rowOfDays.find((item) => item.day === dayName);
      if (item) {
        this.rowOfDays = this.rowOfDays.filter((row) => row.day !== item.day);
      } else {
        this.rowOfDays.push({
          day: dayName,
          fromTime: "08:00",
          endTime: "18:00",
          duration: null,
          maxTurn: null,
          unitId: "",
        });
      }
    },
    async searchLastPlan() {
      this.$store
        .dispatch("plan/searchLastInUsePlan", this.doctorIdSelected)
        .then((res) => {
          if (!res) return;
          this.editMode = true;
          this.startDate = res.fromDate.split("T")[0];
          this.endDate = res.endDate.split("T")[0];
          if (res.saturdays.length > 0) {
            this.weekDays[0].checked = true;
            for (const item of res.saturdays) {
              this.rowOfDays.push({
                day: "Saturdays",
                fromTime: item.fromTime,
                endTime: item.endTime,
                duration: item.duration,
                maxTurn: item.maxTurn,
                unitId: item.unitId,
              });
            }
          }
          if (res.sundays.length > 0) {
            this.weekDays[1].checked = true;
            for (const item of res.sundays) {
              this.rowOfDays.push({
                day: "Sundays",
                fromTime: item.fromTime,
                endTime: item.endTime,
                duration: item.duration,
                maxTurn: item.maxTurn,
                unitId: item.unitId,
              });
            }
          }
          if (res.mondays.length > 0) {
            this.weekDays[2].checked = true;
            for (const item of res.mondays) {
              this.rowOfDays.push({
                day: "Mondays",
                fromTime: item.fromTime,
                endTime: item.endTime,
                duration: item.duration,
                maxTurn: item.maxTurn,
                unitId: item.unitId,
              });
            }
          }
          if (res.tuesdays.length > 0) {
            this.weekDays[3].checked = true;
            for (const item of res.tuesdays) {
              this.rowOfDays.push({
                day: "Tuesdays",
                fromTime: item.fromTime,
                endTime: item.endTime,
                duration: item.duration,
                maxTurn: item.maxTurn,
                unitId: item.unitId,
              });
            }
          }
          if (res.wednesdays.length > 0) {
            this.weekDays[4].checked = true;
            for (const item of res.wednesdays) {
              this.rowOfDays.push({
                day: "Wednesdays",
                fromTime: item.fromTime,
                endTime: item.endTime,
                duration: item.duration,
                maxTurn: item.maxTurn,
                unitId: item.unitId,
              });
            }
          }
          if (res.thursdays.length > 0) {
            this.weekDays[5].checked = true;
            for (const item of res.thursdays) {
              this.rowOfDays.push({
                day: "Thursdays",
                fromTime: item.fromTime,
                endTime: item.endTime,
                duration: item.duration,
                maxTurn: item.maxTurn,
                unitId: item.unitId,
              });
            }
          }
          if (res.fridays.length > 0) {
            this.weekDays[6].checked = true;
            for (const item of res.fridays) {
              this.rowOfDays.push({
                day: "Fridays",
                fromTime: item.fromTime,
                endTime: item.endTime,
                duration: item.duration,
                maxTurn: item.maxTurn,
                unitId: item.unitId,
              });
            }
          }
        });
    },
    convertWeekDayName(name) {
      if (name === "Saturdays") return "شنبه ها";
      if (name === "Sundays") return "یکشنبه ها";
      if (name === "Mondays") return "دوشنبه ها";
      if (name === "Tuesdays") return "سه شنبه ها";
      if (name === "Wednesdays") return " چهارشنبه ها";
      if (name === "Thursdays") return "پنجشنبه ها";
      if (name === "Fridays") return "جمعه ها";
    },
  //   checkMultipleOfFive(index, event) {
  //   if (this.rowOfDays[index].duration % 5 !== 0) {
  //     this.$bvToast.toast(this.$t("toastification.multipleOfFive"), {
  //       variant: "danger",
  //       solid: true,
  //     });
  //   }
  // }
  },
  computed: {
    ...mapGetters({
      allUnits: "units/units",
    }),
    statusVariant() {
      const statusColor = {
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
      };
      return (status) => statusColor[status];
    },
    invalidFeedbackStartDate: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.startDate.$dirty) return error;
        if (!this.$v.startDate.required) error = "required";
        return error;
      },
    },
    invalidFeedbackEndDate: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.endDate.$dirty) return error;
        if (!this.$v.endDate.required) error = "required";
        return error;
      },
    },
    invalidFeedbackSelectDays: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.selectDays.$dirty) return error;
        if (!this.$v.selectDays.required) error = "required";
        return error;
      },
    },
    invalidFeedbackCountOfQueue: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.countOfQueue.$dirty) return error;
        if (!this.$v.countOfQueue.required) error = "required";
        return error;
      },
    },
    invalidFeedbackUnitofPlan: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.searchedUnits.$dirty) return error;
        if (!this.$v.searchedUnits.required) error = "required";
        return error;
      },
    },
    sortedRowOfDays() {
      const orderedDays = [
        "Saturdays",
        "Sundays",
        "Mondays",
        "Tuesdays",
        "Wednesdays",
        "Thursdays",
        "Fridays"
      ];
      return this.rowOfDays.sort((a, b) => {
        return orderedDays.indexOf(a.day) - orderedDays.indexOf(b.day);
      });
    }
  },
  async mounted() {
    this.searchLastPlan();
    this.$store.dispatch("user/findUser", this.doctorIdSelected).then((res) => {
      if (res) {
        for (const unit of res.units) {
          this.units.push(this.allUnits.filter((item) => item._id === unit)[0]);
        }
      }
    });
    // because in editMode dates not work properly
    // setTimeout(() => {
    //   this.showDates = true;
    // }, 1000);
  },
  watch: {},
};
</script>

<style scoped>
.plan-doctor table.table-responsive {
  height: 40vh;
  overflow: auto ;
  background: white !important;
  overflow-x: hidden !important;
}
table{
  background: white !important;
}
table td{
  border-top: none !important;
}
.fixed-head{
  position: sticky;
width: 1130px;
z-index: 3;
top:0%;
}
.fixed-head td:nth-child(1)::after{
  position: absolute;
  content: "";
  width: 1px;
  background: #ccc;
  height: 100%;
  top: 0;
  margin-left: 55px;
}
.fixed-head td:nth-child(2)::after{
  position: absolute;
  content: "";
  width: 1px;
  background: #ccc;
  height: 100%;
  top: 0;
  margin-left: 55px;
}
.fixed-head td:nth-child(3)::after{
  position: absolute;
  content: "";
  width: 1px;
  background: #ccc;
  height: 100%;
  top: 0;
  margin-left: 55px;
}
.fixed-head td:nth-child(4)::after{
  position: absolute;
  content: "";
  width: 1px;
  background: #ccc;
  height: 100%;
  top: 0;
  margin-left: 29px;
}
.fixed-head td:nth-child(5)::after{
  position: absolute;
  content: "";
  width: 1px;
  background: #ccc;
  height: 100%;
  top: 0;
  margin-left: 25px;
}
.fixed-head td:nth-child(6)::after{
  position: absolute;
  content: "";
  width: 1px;
  background: #ccc;
  height: 100%;
  top: 0;
  margin-left: 88px;
}
.fixed-head td:last-child::after{
  display: none !important;
}
 .plan-modal table tr:first-child td:not(:last-child) {
    border-left: none !important;
    border-right: none !important;
}
.plan-content{
  max-height: 94vh;
  overflow-y: unset;
  width: 80%;
}
.maxTurn.form-control{
  margin:auto
}
.custom-select:disabled{
  color: #6e6b7b !important;
}

.table.table-responsive .text-center .td{
  padding-top: 17px !important;
}
.advanceSearch-card .table.table-responsive .text-center .td{
  padding-top: 12px !important;
}
</style>
